module.exports = __webpack_public_path__ + "static/img/RALZ,F_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RALZ,F_1.png
// module id = ZhLU
// module chunks = 0